// ---------------------------------------------------------------------------
// Cloud sync via Clerk unsafeMetadata (frontend-only, no backend).
//
// IMPORTANT: This file must NOT import @clerk/* — that would pull the Clerk
// SDK into the main bundle and break old Android TV WebViews. It talks to a
// tiny bridge (window.__flexCloud) that ONLY the lazy-loaded Clerk chunk
// (src/context/ClerkShell.jsx) installs on modern devices. On legacy devices
// every call returns null/false and local localStorage keeps working.
//
// Synced payload shape (unsafeMetadata.flexwatch):
// {
//   v: 1,
//   lists: [ {id, media_type, title, poster_path, backdrop_path,
//             vote_average, release_date, first_air_date} ],   // max 50
//   continueWatching: [ {id, media_type, title, poster_path,
//             backdrop_path, season, episode, seconds, duration,
//             updatedAt} ],                                    // max 20
//   updatedAt: ISOString
// }
// ---------------------------------------------------------------------------

const MAX_LIST = 50;
const MAX_CONTINUE = 20;

export const isCloudAvailable = () => {
  try {
    return Boolean(
      typeof window !== 'undefined' &&
        window.__flexCloud &&
        typeof window.__flexCloud.read === 'function'
    );
  } catch (e) {
    return false;
  }
};

// Read the raw synced payload; null when unavailable/absent.
export const readCloudData = async () => {
  if (!isCloudAvailable()) return null;
  try {
    const data = await window.__flexCloud.read();
    if (!data || typeof data !== 'object') return null;
    return data;
  } catch (e) {
    return null;
  }
};

// Merge a partial payload into the cloud record and persist it.
// Returns the saved full payload, or null when cloud is unavailable.
export const writeCloudData = async (partial) => {
  if (!isCloudAvailable()) return null;
  try {
    const current = (await readCloudData()) || {};
    const next = {
      ...current,
      ...partial,
      v: 1,
      updatedAt: new Date().toISOString(),
    };
    await window.__flexCloud.write(next);
    return next;
  } catch (e) {
    return null;
  }
};

const minListItem = (m) => ({
  id: m.id,
  media_type: m.media_type || 'movie',
  title: m.title || m.original_title || m.name || m.original_name || '',
  poster_path: m.poster_path || null,
  backdrop_path: m.backdrop_path || null,
  vote_average: m.vote_average || 0,
  release_date: m.release_date || null,
  first_air_date: m.first_air_date || null,
});

const minWatchItem = (w) => ({
  id: w.id,
  media_type: w.media_type || 'movie',
  title: w.title || w.name || w.original_title || w.original_name || '',
  poster_path: w.poster_path || null,
  backdrop_path: w.backdrop_path || null,
  season: w.season || 1,
  episode: w.episode || 1,
  seconds: Math.round(w.seconds || 0),
  duration: Math.round(w.duration || 0),
  updatedAt: w.updatedAt || new Date().toISOString(),
});

export const saveLists = async (myList) =>
  writeCloudData({ lists: (myList || []).slice(0, MAX_LIST).map(minListItem) });

export const saveContinueWatching = async (entries) =>
  writeCloudData({ continueWatching: (entries || []).slice(0, MAX_CONTINUE).map(minWatchItem) });
